<div *ngIf='screenWidth > 1230' class="bmw-lg-noisecatalog-playback-container">
  <div (window:orientationchange)="screenRotate($event)">
    <!-- display player -->
    <div style="width: 60%; float: left">
      <div class="bmw-lg-noisecatalog-playback-player" #player_container>
        <iframe *ngIf="vimeoSafeUrl" [src]="vimeoSafeUrl" width="100%" height="100%" frameborder="0"
          webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        <!--<iframe [src]='vimeoSafeUrl' width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>-->
      </div>

      <!-- diplay video metadata -->
      <div class="bmw-lg-noisecatalog-playback-metadata">
        <div class="row bmw-no-gutter">
          <div class="col-lg-2 oval-filled">{{currentNoiseCatalog?.noiseCatalogDisplayNumber.substr(0,2)}}</div>
          <div class="col-lg-10 bmw-no-gutter" style="margin-left: 5px; font-size: 16px; color: #444">
            <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogDisplayNumber}}</div>
            <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogTitle}}</div>
          </div>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 12px; margin-left: 30px; margin-bottom: 14px">
          <div class="col-lg-2" style="color: #777; font-size: 14px">{{currentNoiseCatalog?.views}} views</div>
          <div class="col-lg-2" style="color: #777; font-size: 14px">
            {{currentNoiseCatalog?.releaseDate | date: 'yyyy-MM-dd'}}</div>
          <div class="col-lg-2"></div>
          <div class="col-lg-2 bmw-no-gutter">
            <div class="col-lg-6 bmw-no-gutter">
              <i class="material-icons"
                [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
                style="float: left" (click)='likeNoiseCatalog()'>thumb_up</i>
              <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.likes}}</div>
            </div>
            <div class="col-lg-6 bmw-no-gutter bmw-align-text-right">
              <i class="material-icons"
                [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
                style="float: left" (click)='dislikeNoiseCatalog()'>thumb_down</i>
              <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.dislikes}}</div>
            </div>
          </div>
          <div class="col-lg-3" style="padding-left: 4%; padding-right: 2%"
            [ngStyle]="{'color': isNoiseCatalogWatchlisted && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }">
            <i class="material-icons" style="float: left" (click)='toggleAddToWatchlist()'>remove_red_eye</i>
            <div style="float: left; margin-left: 5px">Add to Watchlist</div>
          </div>
          <div class="col-lg-1 bmw-no-gutter bmw-align-text-right pointer" data-toggle="modal"
            data-target="#noisecatalogshareContent"
            (click)='noisecatalogshareContent(currentNoiseCatalog?.noiseCatalogId, "noisecatalog", currentNoiseCatalog.mainGroup.mainGroupNumber, currentNoiseCatalog?.noiseCatalogDisplayNumber)'>
            <i class="material-icons" style="float: left">share</i>
            <div style="float: left; margin-left: 5px">Share</div>
          </div>
        </div>
        <div class="line-separator"></div>
        <!-- display video series -->
        <div class="bmw-lg-noisecatalog-playback-noisecatalog-series"
          [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
          <span style="margin-right: 80px;" *ngFor='let series of currentNoiseCatalog?.series'>
            {{series.seriesName}}
          </span>
        </div>
      </div>
    </div>

    <!-- noisecatalogs in channel/watchlist -->
    <div style="width: 30%;float: left; margin-top: 18px">
      <div class="row bmw-no-gutter">
        <div class="col-lg-6 bmw-no-gutter">Up Next</div>
      </div>
      <div class="row bmw-no-gutter" style="margin-top: 15px" *ngFor='let noisecatalog of noiseCatalogList?.slice(0,9)'>
        <div class="col-lg-5 bmw-no-gutter">
          <a [routerLink]='["/noisecatalogplayback"]'
            [queryParams]='{mainGroup: noisecatalog.mainGroup.mainGroupNumber, noisecatalog: noisecatalog.noiseCatalogId,vimeoID: noisecatalog.noiseCatalogVimeoId, watchlist: isWatchlist, playAll: isPlayAll}'>
            <img src="{{videoThumbnail}}" />
          </a>
        </div>
        <div class="col-lg-6 bmw-no-gutter">
          <!-- <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber | highlightSearch: searchKey'></div> -->
          <div class="row bmw-no-gutter"
            [innerHTML]='noisecatalog.noiseCatalogTitle.length > 50 ? noisecatalog.noiseCatalogTitle.substr(0,51)+"..." : noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
          </div>
          <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
            <div class="col-lg-6 bmw-no-gutter"
              [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
            <div class="col-lg-6 bmw-no-gutter">{{noisecatalog.views}} views</div>
          </div>
        </div>
        <div class="col-lg-1 bmw-no-gutter bmw-align-text-right">
          <div class="dropdown dropdown-pull-right btn-group">
            <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
            <ul class="dropdown-menu">
              <li class="row bmw-no-gutter">
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                </div>
                <div class="col-lg-9 bmw-no-gutter pointer" (click)='addNoiseCatalogToWatchlist()'>
                  Add to watchlist
                </div>
              </li>
              <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
                (click)='noisecatalogshareContent(noisecatalog?.noiseCatalogId, "noisecatalog",noisecatalog.mainGroup.mainGroupNumber, noisecatalog?.noiseCatalogDisplayNumber)'>
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons dp48" style="font-size:20px">share</i>
                </div>
                <div class="col-lg-9 bmw-no-gutter">
                  Share
                </div>
              </li>
              <li class="divider"></li>
              <li class="row bmw-no-gutter">
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons" style="font-size:20px">close</i>
                </div>
                <div class="col-lg-9 bmw-no-gutter">
                  Cancel
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bmw-noisecatalog-playback-showmore-button bmw-button-secondary pointer">
        <label style="margin-top: 5px">Show More</label>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230' class="bmw-md-noisecatalog-playback-container">
  <div (window:orientationchange)="screenRotate($event)">
    <!-- display player -->
    <div style="width: 60%; float: left">
      <div class="bmw-md-noisecatalog-playback-player">
        <iframe *ngIf="vimeoSafeUrl" [src]="vimeoSafeUrl" width="100%" height="100%" frameborder="0"
          webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        <!-- <vg-player (onPlayerReady)="onPlayerReady($event)">
          <vg-buffering></vg-buffering>

          <vg-scrub-bar>
            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
          </vg-scrub-bar>

          <vg-controls>
            <div class="pointer" style="padding-top: 16px; color: white" (click)='replayByTen()'>
              <i class="material-icons" style="font-size: 20px">replay_10</i>
            </div>
            <vg-play-pause></vg-play-pause>
            <div class="pointer" style="padding-top: 16px; color: white" (click)='seekByTen()'>
              <i class="material-icons" style="font-size: 20px">forward_10</i>
            </div>

            <vg-playback-button></vg-playback-button>

            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

            <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>

            <vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display>
            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

            <vg-mute></vg-mute>
            <vg-volume></vg-volume>

            <vg-fullscreen></vg-fullscreen>
          </vg-controls>

          <vg-overlay-play></vg-overlay-play>
          <vg-buffering></vg-buffering>
          <img class="bmw-noisecatalog-loading-spinner" [style.display]='showSpinner?"inherit": "none"' src="assets/images/loading-spinner.svg">

          <video [autoplay]='toggleAutoplay' [src]='noisecatalogFile' [vgMedia]="media" #media preload="auto" crossorigin>
          </video>
        </vg-player> -->
      </div>
      <!-- diplay noisecatalog metadata -->
      <div class="bmw-md-noisecatalog-playback-metadata">
        <div class="row bmw-no-gutter">
          <div class="col-md-2 oval-filled">{{currentNoiseCatalog?.noiseCatalogDisplayNumber.substr(0,2)}}</div>
          <div class="col-md-10 bmw-no-gutter" style="margin-left: 5px; font-size: 16px; color: #444">
            <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogDisplayNumber}}</div>
            <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogTitle}}</div>
          </div>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 12px; margin-left: 30px; margin-bottom: 14px">
          <div class="col-md-2" style="color: #777; font-size: 14px">{{currentNoiseCatalog?.views}} views</div>
          <div class="col-md-2 bmw-no-gutter" style="color: #777; font-size: 14px">
            {{currentNoiseCatalog?.releaseDate | date: 'yyyy-MM-dd'}}</div>
          <div class="col-md-3 bmw-no-gutter">
            <div class="col-md-6 bmw-no-gutter">
              <i class="material-icons" style="float: left"
                [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
                (click)='likeNoiseCatalog()'>thumb_up</i>
              <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.likes}}</div>
            </div>
            <div class="col-md-6 bmw-no-gutter bmw-align-text-right">
              <i class="material-icons"
                [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
                style="float: left" (click)='dislikeNoiseCatalog()'>thumb_down</i>
              <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.dislikes}}</div>
            </div>
          </div>
          <div class="col-md-3 bmw-no-gutter"
            [ngStyle]="{'color': isNoiseCatalogWatchlisted && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }">
            <i class="material-icons" style="float: left; margin: 0px 4px 0px 4px"
              (click)='toggleAddToWatchlist()'>remove_red_eye</i>
            <div style="float: left">Add to Watchlist</div>
          </div>
          <div class="col-md-2 bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
            (click)='noisecatalogshareContent(currentNoiseCatalog?.noiseCatalogId, "noisecatalog",currentNoiseCatalog.mainGroup.mainGroupNumber, currentNoiseCatalog?.noiseCatalogDisplayNumber)'>
            <i class="material-icons" style="float: left; margin-left: 25px">share</i>
            <span style="margin-left:5px">Share</span>
          </div>
        </div>
        <div class="line-separator" style="width:100%"></div>
        <!-- display noisecatalog series -->
        <div class="bmw-lg-noisecatalog-playback-noisecatalog-series"
          [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
          <span style="margin-right: 80px;" *ngFor='let series of currentNoiseCatalog?.series'>
            {{series.seriesName}}
          </span>
        </div>
      </div>
    </div>

    <!-- noisecatalogs in channel -->
    <div style="width: 30%;float: left; margin-top: 18px;">
      <div class="row bmw-no-gutter">
        <div class="col-md-6 bmw-no-gutter">Up Next</div>
        <!-- <div class="col-md-6 bmw-no-gutter">
              <div style="float: left; margin-left:35px">Autoplay</div>
              <div class="bmw-toggle-autoplay">
                <div class="slider"></div>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]='toggleAutoplay'>
                  <div class="round" [ngStyle]='{"background-color": toggleAutoplay ? "#2f9612" : "#bf1a22"}'>
                    {{toggleAutoplay ? "On" : "Off"}}
                  </div>
                </label>
              </div>
            </div> -->
      </div>
      <div class="row bmw-no-gutter" style="margin-top: 15px" *ngFor='let noisecatalog of noiseCatalogList?.slice(0,9)'>
        <div class="col-md-5 bmw-no-gutter">
          <a [routerLink]='["/noisecatalogplayback"]'
            [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId,watchlist: isWatchlist, playAll: isPlayAll}'>
            <img src="{{videoThumbnail}}" />
          </a>
        </div>
        <div class="col-md-6 bmw-no-gutter" style="margin-left:7px">
          <!-- <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber | highlightSearch: searchKey'></div> -->
          <div class="row bmw-no-gutter"
            [innerHTML]='noisecatalog.noiseCatalogTitle.length > 30 ? noisecatalog.noiseCatalogTitle.substr(0,31)+"..." : noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
          </div>
          <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
            <div class="col-md-6 bmw-no-gutter"
              [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
            <div class="col-md-6 bmw-no-gutter">{{noisecatalog.views}} views</div>
          </div>
        </div>
        <div class="col-md-1 bmw-no-gutter">
          <div class="dropdown dropdown-pull-right btn-group">
            <i class="material-icons pointer" style="opacity: 0.7"
              data-toggle="dropdown">more_vert</i>
            <ul class="dropdown-menu">
              <li class="row bmw-no-gutter">
                <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                </div>
                <div class="col-md-9 bmw-no-gutter pointer" style="margin-left: 10px"
                  (click)='addNoiseCatalogToWatchlist()'>
                  Add to watchlist
                </div>
              </li>
              <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
                (click)='noisecatalogshareContent(noisecatalog?.noiseCatalogId, "noisecatalog",noisecatalog.mainGroup.mainGroupNumber, noisecatalog?.noiseCatalogDisplayNumber)'>
                <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">share</i>
                </div>
                <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                  Share
                </div>
              </li>
              <li class="divider"></li>
              <li class="row bmw-no-gutter">
                <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons" style="font-size:20px">close</i>
                </div>
                <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                  Cancel
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bmw-noisecatalog-playback-showmore-button bmw-button-secondary pointer">
        <label style="margin-top: 5px">Show More</label>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->

<div *ngIf='screenWidth >= 767 && screenWidth <= 991' class="bmw-sm-noisecatalog-playback-container">
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-noisecatalog-playback-player">
      <iframe *ngIf="vimeoSafeUrl" [src]="vimeoSafeUrl" width="100%" height="100%" frameborder="0" webkitallowfullscreen
        mozallowfullscreen allowfullscreen></iframe>
      <!-- <vg-player (onPlayerReady)="onPlayerReady($event)">
        <vg-buffering></vg-buffering>

        <vg-scrub-bar>
          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
        </vg-scrub-bar>

        <vg-controls>
          <div class="pointer" style="padding-top: 16px; color: white" (click)='replayByTen()'>
            <i class="material-icons" style="font-size: 20px">replay_10</i>
          </div>
          <vg-play-pause></vg-play-pause>
          <div class="pointer" style="padding-top: 16px; color: white" (click)='seekByTen()'>
            <i class="material-icons" style="font-size: 20px">forward_10</i>
          </div>

          <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

          <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>

          <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

          <vg-mute></vg-mute>
          <vg-volume></vg-volume>

          <vg-fullscreen></vg-fullscreen>
        </vg-controls>

        <vg-overlay-play></vg-overlay-play>
        <vg-buffering></vg-buffering>
        <img class="bmw-noisecatalog-loading-spinner" [style.display]='showSpinner?"inherit": "none"' src="assets/images/loading-spinner.svg">

        <video [autoplay]='toggleAutoplay' [src]='noisecatalogFile' [vgMedia]="media" #media preload="auto" crossorigin>
        </video>
      </vg-player> -->
    </div>
    <div class="bmw-xs-noisecatalog-playback-metadata">
      <div class="row bmw-no-gutter">
        <div class="col-sm-2 oval-filled">{{currentNoiseCatalog?.noiseCatalogDisplayNumber.substr(0,2)}}</div>
        <div class="col-sm-10 bmw-no-gutter" style="margin-left: 5px; font-size: 16px; color: #444">
          <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogDisplayNumber}}</div>
          <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogTitle}}</div>
        </div>
      </div>
      <div class="row bmw-no-gutter" style="margin-top: 12px; margin-left: 30px; margin-bottom: 14px">
        <div class="col-sm-2" style="color: #777; font-size: 14px">{{currentNoiseCatalog?.views}} views</div>
        <div class="col-sm-2" style="color: #777; font-size: 14px">
          {{currentNoiseCatalog?.releaseDate | date: 'yyyy-MM-dd'}}</div>
        <div class="col-sm-1"></div>
        <div class="col-sm-2">
          <div class="col-sm-6 bmw-no-gutter">
            <i class="material-icons" style="float: left"
              [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
              (click)='likeNoiseCatalog()'>thumb_up</i>
            <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.likes}}</div>
          </div>
          <div class="col-sm-6 bmw-no-gutter bmw-align-text-right">
            <i class="material-icons" style="float: left"
              [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
              (click)='dislikeNoiseCatalog()'>thumb_down</i>
            <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.dislikes}}</div>
          </div>
        </div>
        <div class="col-sm-3" style="padding-left: 4%; padding-right: 2%"
          [ngStyle]="{'color': isNoiseCatalogWatchlisted && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }">
          <i class="material-icons" style="float: left" (click)='toggleAddToWatchlist()'>remove_red_eye</i>
          <div style="float: left; margin-left: 5px">Add to Watchlist</div>
        </div>
        <div class="col-sm-2 bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
          (click)='noisecatalogshareContent(currentNoiseCatalog?.noiseCatalogId, "noisecatalog", currentNoiseCatalog?.mainGroup.mainGroupNumber, currentNoiseCatalog?.noiseCatalogDisplayNumber)'>
          <i class="material-icons" style="float: left; margin-right: 5px; font-size: 20px">share</i>
          <div>Share</div>
        </div>
      </div>
    </div>
    <div class="line-separator" style="width: 100%"></div>
    <div style="margin: 5px">
      <div class="row bmw-no-gutter" style="margin-top: 10px">
        <div class="col-sm-6 bmw-no-gutter">Up Next</div>
        <div class="col-sm-6 bmw-no-gutter">
          <div class="col-sm-7"></div>
          <!-- <div class="col-sm-5 bmw-no-gutter">
              <div style="float: left; margin-left:35px">Autoplay</div>
              <div class="bmw-toggle-autoplay">
                <div class="slider"></div>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]='toggleAutoplay'>
                  <div class="round" [ngStyle]='{"background-color": toggleAutoplay ? "#2f9612" : "#bf1a22"}'>
                    {{toggleAutoplay ? "On" : "Off"}}
                  </div>
                </label>
              </div>
            </div> -->
        </div>
      </div>
      <div class="row bmw-no-gutter" style="margin-top: 15px" *ngFor='let noisecatalog of noiseCatalogList?.slice(0,9)'>
        <div class="col-sm-4 bmw-no-gutter">
          <a [routerLink]='["/noisecatalogplayback"]'
            [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: isWatchlist, playAll: isPlayAll}'>
            <img src="{{videoThumbnail}}" />
            <!-- <noisecatalog height="84px" width="150px" [src]='noisecatalog?.noisecatalogFileName'></noisecatalog> -->
          </a>
        </div>
        <div class="col-sm-7 bmw-no-gutter" style="font-size: 16px; padding-left:3px">
          <!-- <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber | highlightSearch: searchKey'></div> -->
          <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
          </div>
          <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
            <span>{{noisecatalog.releaseDate | date: 'yyyy-MM-dd'}}</span>
            <span style="margin-left: 15px">{{noisecatalog.views}}</span>
          </div>
        </div>
        <div class="col-sm-1 bmw-no-gutter">
          <div class="dropdown dropdown-pull-right btn-group">
            <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
            <ul class="dropdown-menu">
              <li class="row bmw-no-gutter">
                <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                </div>
                <div class="col-sm-9 bmw-no-gutter pointer" (click)='addNoiseCatalogToWatchlist()'
                  style="margin-left: 10px">
                  Add to watchlist
                </div>
              </li>
              <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
                (click)='noisecatalogshareContent(noisecatalog?.noiseCatalogId, "noisecatalog",noisecatalog.mainGroup.mainGroupNumber, noisecatalog?.noiseCatalogDisplayNumber)'>
                <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">share</i>
                </div>
                <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                  Share
                </div>
              </li>
              <li class="divider"></li>
              <li class="row bmw-no-gutter">
                <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons" style="font-size:20px">close</i>
                </div>
                <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                  Cancel
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bmw-noisecatalog-playback-showmore-button bmw-button-secondary pointer">
        <label style="margin-top: 5px">Show More</label>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>

  </div>
</div>

<!-- mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767' class="bmw-sm-noisecatalog-playback-container">
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-noisecatalog-playback-player">
      <iframe *ngIf="vimeoSafeUrl" [src]="vimeoSafeUrl" width="100%" height="100%" frameborder="0" webkitallowfullscreen
        mozallowfullscreen allowfullscreen></iframe>
      <!-- <vg-player (onPlayerReady)="onPlayerReady($event)">
        <vg-buffering></vg-buffering>

        <vg-scrub-bar>
          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
        </vg-scrub-bar>

        <vg-controls>
          <div class="pointer" style="padding-top: 16px; color: white" (click)='replayByTen()'>
            <i class="material-icons" style="font-size: 20px">replay_10</i>
          </div>
          <vg-play-pause></vg-play-pause>
          <div class="pointer" style="padding-top: 16px; color: white" (click)='seekByTen()'>
            <i class="material-icons" style="font-size: 20px">forward_10</i>
          </div>

          <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

          <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>

          <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

          <vg-mute></vg-mute>
          <vg-volume></vg-volume>

          <vg-fullscreen></vg-fullscreen>
        </vg-controls>

        <vg-overlay-play></vg-overlay-play>
        <vg-buffering></vg-buffering>
        <img class="bmw-noisecatalog-loading-spinner" [style.display]='showSpinner?"inherit": "none"' src="assets/images/loading-spinner.svg">

        <noisecatalog [autoplay]='toggleAutoplay' [vgMedia]="media" #media preload="auto" crossorigin>
        </noisecatalog>
      </vg-player> -->
    </div>
    <div class="bmw-xs-noisecatalog-playback-metadata">
      <div class="row bmw-no-gutter">
        <div style="font-size: 14px">
          <div class="col-xs-2 oval-filled">{{currentNoiseCatalog?.noiseCatalogDisplayNumber.substr(0,2)}}</div>
          <div class="col-xs-10 bmw-no-gutter" style="margin-left: 5px; color: #444">
            <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogDisplayNumber}}</div>
            <div class="row bmw-no-gutter">{{currentNoiseCatalog?.noiseCatalogTitle}}</div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter" style="margin-left: 45px; margin-bottom: 14px">
        <div style="color: #777; font-size: 14px">{{currentNoiseCatalog?.views}} views</div>
      </div>
      <div class="row bmw-no-gutter">
        <div class="col-xs-2 bmw-no-gutter">
          <i class="material-icons" style="float: left"
            [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Liked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
            (click)='likeNoiseCatalog()'>thumb_up</i>
          <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.likes}}</div>
        </div>
        <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
          <i class="material-icons" style="float: left"
            [ngStyle]="{'color': (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (likeOrDislikeNoiseCatalog === 'Disliked') && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }"
            (click)='dislikeNoiseCatalog()'>thumb_down</i>
          <div style="float: left; margin-left: 5px">{{currentNoiseCatalog?.dislikes}}</div>
        </div>
        <div class="col-xs-4"></div>
        <div class="col-xs-2 bmw-no-gutter bmw-align-text-right"
          [ngStyle]="{'color': isNoiseCatalogWatchlisted && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : isNoiseCatalogWatchlisted && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#000000' }">
          <i class="material-icons" (click)='toggleAddToWatchlist()'>remove_red_eye</i>
        </div>
        <div class="col-xs-2 bmw-no-gutter bmw-align-text-right pointer" data-toggle="modal"
          data-target="#noisecatalogshareContent"
          (click)='noisecatalogshareContent(currentNoiseCatalog?.noiseCatalogId, "noisecatalog", currentNoiseCatalog?.mainGroup.mainGroupNumber, currentNoiseCatalog?.noiseCatalogDisplayNumber)'>
          <i class="material-icons">share</i>
        </div>
      </div>
      <div class="line-separator" style="width: 100%"></div>
      <!-- display noisecatalog series -->
      <div class="bmw-xs-noisecatalog-playback-noisecatalog-series"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
        <span style="margin-right: 80px;" *ngFor='let series of currentNoiseCatalog?.series'>
          {{series.seriesName}}
        </span>
      </div>
    </div>
    <div class="line-separator" style="width: 100%"></div>
    <div style="margin: 5px">
      <div class="row bmw-no-gutter" style="margin-top: 10px">
        <div class="col-xs-6 bmw-no-gutter">Up Next</div>
        <div class="col-xs-6 bmw-no-gutter">
          <div class="col-xs-3"></div>
          <!-- <div class="col-xs-9 bmw-no-gutter">
              <div style="float: left">Autoplay</div>
              <div class="bmw-toggle-autoplay">
                <div class="slider"></div>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]='toggleAutoplay'>
                  <div class="round" [ngStyle]='{"background-color": toggleAutoplay ? "#2f9612" : "#bf1a22"}'>
                    {{toggleAutoplay ? "On" : "Off"}}
                  </div>
                </label>
              </div>
            </div> -->
        </div>
      </div>
      <div class="row bmw-no-gutter" style="margin-top: 15px" *ngFor='let noisecatalog of noiseCatalogList?.slice(0,9)'>
        <div class="col-xs-6 bmw-no-gutter">
          <a [routerLink]='["/noisecatalogplayback"]'
            [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: isWatchlist, playAll: isPlayAll}'>
            <img src="{{videoThumbnail}}" />
            <!-- <noisecatalog height="84px" width="150px" [src]='noisecatalog?.noisecatalogFileName'></noisecatalog> -->
          </a>
        </div>
        <div class="col-xs-5 bmw-no-gutter">
          <!-- <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber | highlightSearch: searchKey'></div> -->
          <div class="row bmw-no-gutter"
            [innerHTML]='noisecatalog.noiseCatalogTitle.length > 19 ? noisecatalog.noiseCatalogTitle.substr(0,20)+"..." : noisecatalog.noiseCatalogTitle | highlightSearch: searchKey'>
          </div>
          <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
            <div class="col-xs-6 bmw-no-gutter"
              [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
            <div class="col-xs-6 bmw-no-gutter">{{noisecatalog.views}} views</div>
          </div>
        </div>
        <div class="col-xs-1 bmw-no-gutter">
          <div class="dropdown dropdown-pull-right btn-group">
            <i class="material-icons pointer" style="opacity: 0.7"
              data-toggle="dropdown">more_vert</i>
            <ul class="dropdown-menu">
              <li class="row bmw-no-gutter">
                <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                </div>
                <div class="col-xs-9 bmw-no-gutter pointer" (click)='addNoiseCatalogToWatchlist()'
                  style="margin-left: 10px">
                  Add to watchlist
                </div>
              </li>
              <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#noisecatalogshareContent"
                (click)='noisecatalogshareContent(noisecatalog?.noiseCatalogId, "noisecatalog",noisecatalog.mainGroup.mainGroupNumber, noisecatalog?.noiseCatalogDisplayNumber)'>
                <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">share</i>
                </div>
                <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                  Share
                </div>
              </li>
              <li class="divider"></li>
              <li class="row bmw-no-gutter">
                <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons" style="font-size:20px">close</i>
                </div>
                <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                  Cancel
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bmw-noisecatalog-playback-showmore-button bmw-button-secondary pointer">
        <label style="margin-top: 5px">Show More</label>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>